const translations = {
  en: {
    locale: 'en-US',
    home: 'Home', about: 'About', darkMode: 'Dark mode', github: 'View my current GitHub profile',
    projects: 'View projects', contact: 'Connect on LinkedIn', language: 'Language', english: 'English', japanese: '日本語',
    loading: 'Loading portfolio…', loadError: 'The portfolio could not be loaded. Please try again.', retry: 'Try again',
    archived: 'Archived project', archiveNote: 'Live demos are retired. These screenshots show the original working versions.',
    openProject: 'View project details', close: 'Close project details', repository: 'View repository', gallery: 'Project screenshots',
    previous: 'Previous image', next: 'Next image', image: 'Image', of: 'of', selectImage: 'Show image', screenshot: 'screenshot', fullSizeImage: 'Open full-size image',
    notFound: 'Page not found', notFoundDetail: 'This address does not match a page in this portfolio.',
    backHome: 'Return home', copyright: 'Copyright',
    pauseAnimation: 'Pause animation', playAnimation: 'Play animation',
    navigation: 'Main navigation', skipContent: 'Skip to content', projectsNav: 'Projects', experienceNav: 'Experience',
    heroEyebrow: 'Software · Systems · Support', projectsKicker: 'Selected projects', technologies: 'Technologies',
    introEyebrow: 'Engineering & operations', readAbout: 'More about me',
    systemsTools: 'Systems & operations', developmentTools: 'Application development',
    aiEngineering: 'AI development practices', securityDocumentation: 'Security & documentation',
    skillsIntro: 'Tools used across my projects, with links to examples of my systems, security, and AI development work.',
    skillEvidence: 'See supporting example', skillNetworking: 'Network troubleshooting', skillITSupport: 'IT support',
    skillAIDevelopment: 'AI-assisted development', skillPromptContext: 'Prompt & context design', skillAgentCoordination: 'Agent coordination',
    skillVerification: 'Verification & review', skillAccessControl: 'Access control', skillLeastPrivilege: 'Least privilege',
    skillSecurityTraining: 'Security awareness training', skillDocumentation: 'Technical documentation',
    focusOperations: 'IT & network operations', focusDevelopment: 'Software development', focusDocumentation: 'Technical documentation',
    connectHeading: 'Let’s connect', connectNote: 'Find my code, professional background, and writing.', backToTop: 'Back to top',
    credentialsHeading: 'Certifications', educationHeading: 'Education & training',
    degreeAudio: 'Associate’s degree in Recording Technology, Audio Engineering & Production',
    trainingCode: 'Code Fellows · Full Stack JavaScript certificate',
    certGoogleIT: 'Google IT Support Professional Certificate', certGoogleSecurity: 'Google Cybersecurity Certificate',
    certSecurity: 'CompTIA Security+', certVideoSurveillance: 'Video Surveillance Tech',
    credentialIssued: 'Issued', credentialExpires: 'Expires', opensNewTab: 'opens in a new tab',
    featuredCaseStudy: 'Featured case study', caseStudyCard: 'Case study', readCaseStudy: 'Read case study', caseStudy: 'Engineering case study',
    archiveHeading: 'Project archive', backToProjects: 'Back to projects', caseStudyContents: 'In this case study',
    caseStudyStack: 'Technology stack', caseStudyStatus: 'Project status', caseStudyWork: 'Current work',
    returnCaseOverview: 'Back to overview',
    currentProject: 'Personal project', readJournal: 'Read project journal',
    caseStudySources: 'Full project breakdown on GitHub',
    caseStudySourcesNav: 'GitHub sources', exploreSkills: 'Explore skills',
    shoreSurprise: 'A little surprise from the shore', shoreNoteTitle: 'A note from the shore',
    shoreNoteMessage: 'A little curiosity goes a long way. Thanks for exploring.', closeShoreNote: 'Close the shoreline note',
    openVideo: 'Open the diagnostic clip', videoFallback: 'Your browser cannot play this video. Use the link below to open the clip.',
  },
  ja: {
    locale: 'ja-JP',
    home: 'ホーム', about: 'プロフィール', darkMode: 'ダークモード', github: '現在のGitHubプロフィールを開く',
    projects: 'プロジェクトを見る', contact: 'LinkedInで連絡する', language: '表示言語', english: 'English', japanese: '日本語',
    loading: 'ポートフォリオを読み込んでいます…', loadError: 'ポートフォリオを読み込めませんでした。もう一度お試しください。', retry: '再試行',
    archived: '過去のプロジェクト', archiveNote: '公開デモは終了しています。スクリーンショットは当時の動作画面です。',
    openProject: 'プロジェクトの詳細を表示', close: 'プロジェクトの詳細を閉じる', repository: 'ソースコードを見る', gallery: 'プロジェクトのスクリーンショット',
    previous: '前の画像', next: '次の画像', image: '画像', of: '/', selectImage: '画像を表示', screenshot: 'スクリーンショット', fullSizeImage: '画像を原寸で開く',
    notFound: 'ページが見つかりません', notFoundDetail: 'このアドレスに対応するページはありません。',
    backHome: 'ホームに戻る', copyright: '著作権',
    pauseAnimation: 'アニメーションを停止', playAnimation: 'アニメーションを再生',
    navigation: 'メインナビゲーション', skipContent: '本文へ移動', projectsNav: '制作実績', experienceNav: '職歴',
    heroEyebrow: 'ソフトウェア開発・システム運用・ITサポート', projectsKicker: '制作実績', technologies: '使用技術',
    introEyebrow: '開発と運用', readAbout: 'プロフィールを見る',
    systemsTools: 'システム・運用', developmentTools: 'アプリケーション開発',
    aiEngineering: 'AI開発の実践', securityDocumentation: 'セキュリティ・技術文書',
    skillsIntro: 'プロジェクトで使う技術と実践です。リンクから、システム運用・セキュリティ・AI開発の実例をご覧いただけます。',
    skillEvidence: '関連する実例を見る', skillNetworking: 'ネットワーク障害対応', skillITSupport: 'ITサポート',
    skillAIDevelopment: 'AI支援による開発', skillPromptContext: 'プロンプト・前提情報の設計', skillAgentCoordination: 'エージェント間の連携',
    skillVerification: '検証・レビュー', skillAccessControl: 'アクセス制御', skillLeastPrivilege: '最小権限',
    skillSecurityTraining: 'セキュリティ意識向上研修', skillDocumentation: '技術文書の作成',
    focusOperations: 'IT・ネットワーク運用', focusDevelopment: 'ソフトウェア開発', focusDocumentation: '技術文書の作成',
    connectHeading: '連絡先', connectNote: 'ソースコード、職歴、執筆記事はこちらからご覧いただけます。', backToTop: 'ページの先頭へ',
    credentialsHeading: '認定資格', educationHeading: '学歴・研修',
    degreeAudio: 'レコーディング技術・音響工学・音楽制作の準学士号',
    trainingCode: 'コードフェローズ · JavaScriptフルスタック開発課程修了',
    certGoogleIT: 'Google ITサポート プロフェッショナル認定資格', certGoogleSecurity: 'Google サイバーセキュリティ認定資格',
    certSecurity: 'CompTIA Security+', certVideoSurveillance: '映像監視技術者',
    credentialIssued: '取得', credentialExpires: '有効期限', opensNewTab: '新しいタブで開きます',
    featuredCaseStudy: '注目のケーススタディ', caseStudyCard: 'ケーススタディ', readCaseStudy: 'ケーススタディを読む', caseStudy: '開発事例',
    archiveHeading: '過去のプロジェクト', backToProjects: '制作実績に戻る', caseStudyContents: 'このケーススタディの内容',
    caseStudyStack: '使用技術', caseStudyStatus: 'プロジェクトの進捗', caseStudyWork: '現在の取り組み',
    returnCaseOverview: '概要に戻る',
    currentProject: '個人プロジェクト', readJournal: 'プロジェクト日誌を読む',
    caseStudySources: 'GitHubで詳しいプロジェクト内容を見る',
    caseStudySourcesNav: 'GitHubの資料', exploreSkills: '技術スキルを見る',
    shoreSurprise: '海辺の小さなサプライズ', shoreNoteTitle: '海辺からの小さな便り',
    shoreNoteMessage: '小さな好奇心が、新しい発見につながります。ここまで見てくださって、ありがとうございます。', closeShoreNote: '海辺の便りを閉じる',
    openVideo: '検証用動画を開く', videoFallback: 'このブラウザーでは動画を再生できません。下のリンクから動画を開いてください。',
  },
};

export function getLabels(language) {
  return translations[language === 'ja' ? 'ja' : 'en'];
}

export function readPreference(key, fallback) {
  try { return window.localStorage.getItem(key) || fallback; }
  catch { return fallback; }
}

export function savePreference(key, value) {
  // Storage can be unavailable in private browsers; the controls still work.
  try { window.localStorage.setItem(key, value); } catch { /* Session-only preference. */ }
}
